import React from 'react';
import { colors } from 'src/styles/index';
import styled from 'styled-components';
import {
  getBrandingColor, colorTypes, getBrandingStyleOverride, styleOverrides,
} from 'src/branding';

const StyledHeader = styled.h1`
      color: ${getBrandingColor(colorTypes.fontHeader)};
      font-weight: '500';
      font-size: '2.3rem';
    ${getBrandingStyleOverride(styleOverrides.headerText)};
`;

export const Header = ({ children, style, ...props }) => (
  <StyledHeader
    style={{
      ...style,
    }}
    {...props}
  >
    {children}
  </StyledHeader>
);
